import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientDentalProcedure, PatientDentalProcedureData } from '../../../interfaces/masters/patient-dental-procedure';
import { PatientDentalProcedureApi } from '../api/patient-dental-procedure.api';


@Injectable()
export class PatientDentalProcedureService extends PatientDentalProcedureData{

  constructor(private api: PatientDentalProcedureApi) {
    super();    
  }
  list(url: string): Observable<PatientDentalProcedure[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<PatientDentalProcedure>{
      return this.api.getById(url); 
  }

  create(url: string, data:PatientDentalProcedure): Observable<PatientDentalProcedure> {
    return this.api.add(url,data);
  }

  update(url: string, data:PatientDentalProcedure): Observable<PatientDentalProcedure> {
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> { 
    return this.api.delete(url);
  } 
}
